/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { EuiFlexGroup } from '@elastic/eui'

import ExtendTrialButton from '@modules/trial-components/ExtendTrialButton'
import { FormattedMessage } from '@modules/i18n'

interface Props {
  onTrialExtensionSuccess: () => void
}

const ExtendTrialSection: React.FunctionComponent<Props> = ({ onTrialExtensionSuccess }) => (
  <EuiFlexGroup justifyContent='center' alignItems='baseline' gutterSize='xs'>
    <ExtendTrialButton
      type='link'
      source_component_id='expired_badge_modal'
      buttonProps={{ style: { fontWeight: 'bold' } }}
      prefixMessage={
        <FormattedMessage
          id='stateful-trial-modal.need-more-time'
          defaultMessage='Need more time? '
        />
      }
      onSuccess={onTrialExtensionSuccess}
    >
      <FormattedMessage id='stateful-trial-modal.extend' defaultMessage='Extend your trial' />
    </ExtendTrialButton>
  </EuiFlexGroup>
)

export default ExtendTrialSection
